import { useQuery } from '@tanstack/react-query';
import { configService } from '../api/config';

/**
 * Hook para buscar a URL do Metabase configurada no backend
 */
export const useMetabaseUrl = () => {
  return useQuery({
    queryKey: ['metabase-url'],
    queryFn: () => configService.getMetabaseUrl(),
    staleTime: 5 * 60 * 1000, // 5 minutos (configuração não muda frequentemente)
    retry: 2,
    retryDelay: 1000,
  });
};